import { io } from "socket.io-client";
import { SOCKET_ORIGIN, WS_PATH } from "./backend-config";

let _voiceSocket: ReturnType<typeof io> | null = null;

export function getVoiceSocket(): ReturnType<typeof io> {
  if (!_voiceSocket) {
    _voiceSocket = io(`${SOCKET_ORIGIN}/voice`, { transports: ["websocket"], path: WS_PATH });
  }
  return _voiceSocket;
}

export function disconnectVoiceSocket(): void {
  if (_voiceSocket) {
    _voiceSocket.disconnect();
    _voiceSocket = null;
  }
}

/**
 * Schickt das aufgenommene Audio über den `/voice`-Socket und wartet auf die
 * vollständige Whisper-Transkription, die der Server auf **derselben** Socket als
 * `transcription`-Event zurückschickt (Batch — streambare Teilantworten: später).
 */
export async function transcribeViaVoice(blob: Blob, ext: string): Promise<string> {
  const socket = getVoiceSocket();
  if (!socket.connected) {
    await new Promise<void>((resolve) => socket.once("connect", resolve));
  }
  const audio = await blob.arrayBuffer();

  return new Promise<string>((resolve, reject) => {
    const timeout = setTimeout(() => {
      cleanup();
      reject(new Error("Transcription timeout after 30s"));
    }, 30_000);

    function onResult(payload: { text?: string }): void {
      cleanup();
      resolve(payload?.text ?? "");
    }
    function onError(payload: { message?: string }): void {
      cleanup();
      reject(new Error(payload?.message ?? "Transcription failed"));
    }
    function cleanup(): void {
      clearTimeout(timeout);
      socket.off("transcription", onResult as Parameters<typeof socket.off>[1]);
      socket.off("transcription_error", onError as Parameters<typeof socket.off>[1]);
    }

    socket.on("transcription", onResult as Parameters<typeof socket.on>[1]);
    socket.on("transcription_error", onError as Parameters<typeof socket.on>[1]);

    // Full audio as one chunk, then end-of-stream marker.
    socket.emit("audio_chunk", audio);
    socket.emit("audio_end", { ext });
  });
}
